export { default as closest } from './closest';
export { default as delegate } from './delegate';
export { default as dispatch } from './dispatch';
export { default as getAttributes } from './get-attributes';
export { default as matches } from './matches';
export { default as parents } from './parents';
export { default as parseUrl } from './parse-url';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../../../src/vendor/dom-utils/index.ts